import {throttle} from "../../../utils/decorators/throttle";
import {SIDEBAR} from "../../constants";

export const initAsideSidebar = () => {
	if (SIDEBAR.OPTIONS)
	{
		const MS = 500;
		
		throttle(SIDEBAR.OPTIONS.changeSize(), MS);
	}
};
